module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_kamakura-ab90e916c7603a40728fcc7231e4d549.jpg";